<template>
  <footer class="footer-bar">
    <div class="footer-left">
      <span class="footer-logo">
        <span class="footer-dot"></span>
        <span class="footer-dot"></span>
        <span class="footer-dot"></span>
        <span class="footer-dot"></span>
        <span class="footer-dot"></span>
        <span class="footer-name">金蝶云大厦</span>
      </span>
      <span class="footer-divider">|</span>
      <span class="footer-label">线上艺术馆</span>
      <!-- <button class="footer-follow">+关注</button> -->
    </div>
    <div class="footer-actions">
      <div class="footer-action" @click="handleLike">
        <img 
          :src="likeIcon" 
          alt="like" 
          :class="['footer-icon', { 'liked': isLiked }]" 
        />
        <div class="footer-num">{{ likeCount }}</div>
      </div>
      <!-- <div class="footer-action" @click="handleShare">
        <img src="@/assets/images/share.svg" alt="like" class="footer-icon" />
        <div class="footer-num">{{ shareCount }}</div>
      </div> -->
      <!-- <div class="footer-action">
        <svg viewBox="0 0 24 24" class="footer-icon">
          <path d="M12 21C12 21 4 13.5 4 8.5A4.5 4.5 0 0 1 12 4a4.5 4.5 0 0 1 8 4.5C20 13.5 12 21 12 21z" fill="none"
            stroke="#2d2418" stroke-width="2" />
        </svg>
        <div class="footer-num">5</div>
      </div> -->
    </div>
  </footer>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import likeIcon from '@/assets/images/like.svg';

const emits = defineEmits(['onLike', 'onShare']);
const props = defineProps({
  likeCount: {
    type: Number,
    default: 0
  },
  isLiked: {
    type: Boolean
  },
  shareCount: {
    type: Number,
    default: 0
  }
});

// 点赞方法
const handleLike = () => {
  emits('onLike', !props.isLiked);
};

const handleShare = () => {
  emits('onShare')
};
</script>

<style scoped lang="scss">
.footer-bar {
  position: fixed;
  left: 0;
  bottom: 0;;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 10px 8px 10px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-top: 1px solid #eee;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.footer-left {
  display: flex;
  align-items: center;

  .footer-logo {
    display: flex;
    align-items: center;

    .footer-dot {
      width: 7px;
      height: 7px;
      background: #bdbdbd;
      border-radius: 50%;
      display: inline-block;
      margin-right: 2px;

      &:nth-child(2) {
        width: 5px;
        height: 5px;
      }

      &:nth-child(3) {
        width: 4px;
        height: 4px;
      }

      &:nth-child(4) {
        width: 3px;
        height: 3px;
      }

      &:nth-child(5) {
        width: 2px;
        height: 2px;
      }
    }

    .footer-name {
      font-weight: bold;
      font-size: 12px;
      color: #888;
      font-style: italic;
      margin-left: 4px;
    }
  }

  .footer-divider {
    color: #bbb;
    margin: 0 10px;
    font-size: 12px;
  }

  .footer-label {
    color: #222;
    font-size: 12px;
    margin-right: 10px;
  }

  .footer-follow {
    background: #f3f3f3;
    border: none;
    border-radius: 3px;
    padding: 4px 16px;
    font-size: 12px;
    color: #222;
    cursor: pointer;
    margin-left: 2px;
    transition: background 0.2s;

    &:hover {
      background: #e0e0e0;
    }
  }
}

.footer-actions {
  display: flex;
  align-items: flex-end;
  padding-right: 48px;

  .footer-action {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 10px;
    cursor: pointer;
    transition: transform 0.2s;

    &:active {
      transform: scale(0.95);
    }

    .footer-icon {
      width: 24px;
      height: 24px;
      display: block;
      transition: all 0.3s ease;
      filter: brightness(0) saturate(100%) invert(15%) sepia(8%) saturate(1000%) hue-rotate(15deg) brightness(95%) contrast(90%);

      &.liked {
        filter: brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(2000%) hue-rotate(340deg) brightness(95%) contrast(90%);
        animation: likeAnimation 0.4s ease;
      }
    }

    .footer-num {
      font-size: 12px;
      color: #2d2418;
      margin-top: 2px;
      transition: color 0.3s;
    }
  }

  @keyframes likeAnimation {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>